import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-blogs-component',
  imports: [MatCardModule],
  templateUrl: './blogs-component.html',
  styleUrl: './blogs-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogsComponent {}
